import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../defaultTheme";
import FormFeedback from "../FormFeedback";
import FormLabel from "../FormLabel";
import { SIZE_OPTIONS, RESIZE_OPTIONS } from "./consts";
import { rtlSpacing } from "../utils/rtl";
import getSpacingToken from "../common/getSpacingToken";
var Field = styled.label.withConfig({
  displayName: "Textarea__Field",
  componentId: "sc-1ezoqgy-0"
})(["font-family:", ";display:flex;width:100%;height:", ";flex-direction:column;position:relative;flex:", ";margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.fontFamily;
}, function (_ref2) {
  var fullHeight = _ref2.fullHeight;
  return fullHeight && "100%";
}, function (_ref3) {
  var fullHeight = _ref3.fullHeight;
  return fullHeight && "1";
}, getSpacingToken);
Field.defaultProps = {
  theme: defaultTheme
};

var getFontSize = function getFontSize(_ref4) {
  var _tokens;

  var theme = _ref4.theme,
      size = _ref4.size;
  var tokens = (_tokens = {}, _defineProperty(_tokens, SIZE_OPTIONS.SMALL, theme.orbit.fontSizeInputSmall), _defineProperty(_tokens, SIZE_OPTIONS.NORMAL, theme.orbit.fontSizeInputNormal), _tokens);
  return tokens[size];
};

var getLineHeight = function getLineHeight(_ref5) {
  var _tokens2;

  var theme = _ref5.theme,
      size = _ref5.size;
  var tokens = (_tokens2 = {}, _defineProperty(_tokens2, SIZE_OPTIONS.SMALL, theme.orbit.lineHeightTextSmall), _defineProperty(_tokens2, SIZE_OPTIONS.NORMAL, theme.orbit.lineHeightTextNormal), _tokens2);
  return tokens[size];
};

var getPadding = function getPadding(_ref6) {
  var _tokens3;

  var theme = _ref6.theme,
      size = _ref6.size;
  var tokens = (_tokens3 = {}, _defineProperty(_tokens3, SIZE_OPTIONS.SMALL, theme.orbit.paddingTextareaSmall), _defineProperty(_tokens3, SIZE_OPTIONS.NORMAL, theme.orbit.paddingTextareaNormal), _tokens3);
  return rtlSpacing(tokens[size]);
};

var StyledTextArea = styled.textarea.withConfig({
  displayName: "Textarea__StyledTextArea",
  componentId: "sc-1ezoqgy-1"
})(["appearance:none;box-sizing:border-box;display:block;width:100%;height:", ";padding:", ";border-radius:", ";box-shadow:inset 0 0 0 ", ";background-color:", ";color:", ";font-size:", ";line-height:", ";cursor:", ";font-family:", ";resize:", ";transition:box-shadow ", " ease-in-out;min-height:44px;flex:", ";border:1px solid transparent;overflow:auto;&::placeholder{color:", ";}&:hover{box-shadow:", ";}&:focus{box-shadow:", ";outline:none;}"], function (_ref7) {
  var fullHeight = _ref7.fullHeight;
  return fullHeight && "100%";
}, getPadding, function (_ref8) {
  var theme = _ref8.theme;
  return theme.orbit.borderRadiusNormal;
}, function (_ref9) {
  var theme = _ref9.theme,
      error = _ref9.error;
  return "".concat(theme.orbit.borderWidthInput, " ").concat(error ? theme.orbit.borderColorInputError : theme.orbit.borderColorInput);
}, function (_ref10) {
  var disabled = _ref10.disabled,
      theme = _ref10.theme;
  return disabled ? theme.orbit.backgroundInputDisabled : theme.orbit.backgroundInput;
}, function (_ref11) {
  var disabled = _ref11.disabled,
      theme = _ref11.theme;
  return disabled ? theme.orbit.colorTextInputDisabled : theme.orbit.colorTextInput;
}, getFontSize, getLineHeight, function (_ref12) {
  var disabled = _ref12.disabled;
  return disabled ? "not-allowed" : "text";
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.orbit.fontFamily;
}, function (_ref14) {
  var resize = _ref14.resize;
  return resize;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.orbit.durationFast;
}, function (_ref16) {
  var fullHeight = _ref16.fullHeight;
  return fullHeight && "1";
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.orbit.colorPlaceholderInput;
}, function (_ref18) {
  var disabled = _ref18.disabled,
      theme = _ref18.theme,
      error = _ref18.error;
  return !disabled && "inset 0 0 0 ".concat(theme.orbit.borderWidthInput, " ").concat(error ? theme.orbit.borderColorInputErrorHover : theme.orbit.borderColorInputHover);
}, function (_ref19) {
  var theme = _ref19.theme,
      disabled = _ref19.disabled;
  return !disabled && "inset 0 0 0 2px ".concat(theme.orbit.borderColorInputFocus);
});
StyledTextArea.defaultProps = {
  theme: defaultTheme
}; // $FlowExpected

var Textarea = React.forwardRef(function (props, ref) {
  var _props$size = props.size,
      size = _props$size === void 0 ? SIZE_OPTIONS.NORMAL : _props$size,
      disabled = props.disabled,
      _props$resize = props.resize,
      resize = _props$resize === void 0 ? RESIZE_OPTIONS.VERTICAL : _props$resize,
      dataTest = props.dataTest,
      spaceAfter = props.spaceAfter;
  return React.createElement(Field, {
    fullHeight: props.fullHeight,
    spaceAfter: spaceAfter
  }, props.label && React.createElement(FormLabel, {
    filled: !!props.value,
    disabled: disabled
  }, props.label), React.createElement(StyledTextArea, {
    "data-test": dataTest,
    name: props.name,
    value: props.value,
    rows: props.rows,
    size: size,
    fullHeight: props.fullHeight,
    disabled: disabled,
    error: props.error,
    placeholder: props.placeholder,
    maxLength: props.maxLength,
    onChange: props.onChange,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    resize: resize,
    tabIndex: props.tabIndex,
    ref: ref
  }), props.help && !props.error && React.createElement(FormFeedback, {
    type: "help"
  }, props.help), props.error && React.createElement(FormFeedback, {
    type: "error"
  }, props.error));
});
Textarea.displayName = "Textarea";
export default Textarea;